/* IU Home 3.0.0: presentation only. Native product/cart/favorite actions are untouched. */
(() => {
  const init = scope => {
    scope.querySelectorAll('[data-iu-home-carousel]').forEach(section => {
      if (section.dataset.iuHomeReady) return;
      const rail = section.querySelector('[data-iu-home-rail]');
      const prev = section.querySelector('[data-iu-home-prev]');
      const next = section.querySelector('[data-iu-home-next]');
      const range = section.querySelector('[data-iu-home-range]');
      if (!rail || !prev || !next || !range) return;
      section.dataset.iuHomeReady = 'true';
      const update = () => {
        const cards = [...rail.children];
        if (!cards.length) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const stride = cards[0].getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.round((rail.clientWidth + gap) / stride));
        const start = Math.min(cards.length, Math.round(rail.scrollLeft / stride) + 1);
        range.textContent = `${start}–${Math.min(cards.length,start + visible - 1)} din ${cards.length}`;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const move = direction => {
        const first = rail.firstElementChild;
        if (!first) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const stride = first.getBoundingClientRect().width + gap;
        const count = Math.max(1,Math.round((rail.clientWidth + gap) / stride));
        rail.scrollBy({left:direction * count * stride,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      prev.addEventListener('click',() => move(-1));
      next.addEventListener('click',() => move(1));
      let pending = false;
      rail.addEventListener('scroll',() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {pending=false;update();});
      },{passive:true});
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(rail);
      else window.addEventListener('resize',update,{passive:true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
